import React from "react";

const OPTIONS = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
];

const DateRangeFilter = ({ value, onChange }) => (
  <div className="date-range-filter" role="group" aria-label="Date range">
    {OPTIONS.map((opt) => (
      <button
        key={opt.value}
        type="button"
        className={`date-range-option ${value === opt.value ? "active" : ""}`}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default DateRangeFilter;
